var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZoomIn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.25 7A.75.75 0 0 1 5 6.25h1.25V5a.75.75 0 0 1 1.5 0v1.25H9a.75.75 0 0 1 0 1.5H7.75V9a.75.75 0 0 1-1.5 0V7.75H5A.75.75 0 0 1 4.25 7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 1.25a5.75 5.75 0 1 0 3.501 10.312l2.969 2.968a.75.75 0 1 0 1.06-1.06l-2.968-2.97A5.75 5.75 0 0 0 7 1.25M2.75 7a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgZoomIn);
export default ForwardRef;